// @flow
import React from 'react';
import './DDLLoader.module.scss';

export default class DDLLoader extends React.PureComponent {
  render() {
    return <div styleName="dropdown-background" />;
  }
}
